import { c as _c } from "react/compiler-runtime";
import { useGivenAnswers } from '../_data/useGivenAnswers';
import { ResultCategorisationRendered, ResultRendered } from '@/app/decisionToolArticle/_data/decisionToolRendered.types';
import { getHasUnansweredQuestions } from '../_data/filterQuestions';
import { getRelevantResults } from '../_data/filterResults';
import { UncategorisedResults } from './UncategorisedResults';
import { CategorisedResults } from './CategorisedResults';
import { AnyRenderedQuestion } from '../_questions/question.types';
import { DecisionToolTransitionState } from '../useStartQuestionTransition';
export const Results = t0 => {
  const $ = _c(13);
  const {
    resultCategorisations,
    results,
    questions,
    pageTitle,
    isDelayElapsed
  } = t0;
  const [givenAnswers] = useGivenAnswers(questions);
  const hasUnansweredQuestions = getHasUnansweredQuestions(questions, givenAnswers);
  if (hasUnansweredQuestions || !isDelayElapsed) {
    return null;
  }
  let t1;
  if ($[0] !== givenAnswers || $[1] !== questions || $[2] !== results) {
    t1 = getRelevantResults(results, questions, givenAnswers);
    $[0] = givenAnswers;
    $[1] = questions;
    $[2] = results;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const relevantResults = t1;
  if (resultCategorisations.length === 0) {
    let t2;
    if ($[4] !== pageTitle || $[5] !== questions || $[6] !== relevantResults) {
      t2 = <UncategorisedResults relevantResults={relevantResults} questions={questions} pageTitle={pageTitle} />;
      $[4] = pageTitle;
      $[5] = questions;
      $[6] = relevantResults;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    return t2;
  }
  let t2;
  if ($[8] !== pageTitle || $[9] !== questions || $[10] !== relevantResults || $[11] !== resultCategorisations) {
    t2 = <CategorisedResults resultCategorisations={resultCategorisations} relevantResults={relevantResults} questions={questions} pageTitle={pageTitle} />;
    $[8] = pageTitle;
    $[9] = questions;
    $[10] = relevantResults;
    $[11] = resultCategorisations;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
};